"use client";
import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import BasicPopover from "./BasicPopover";
import { ExperienceObj } from "@/app/@types/experienceobj";

/**
 * A React component used to display a single YEX experience.
 *
 * @remarks
 * This component displays a single YEX experience in the panel of two YEX
 * experience options per row while listing all current available experiences
 * by Deep On/Deep Off Category.  It is a child to the CategoryPanelInner component that holds
 * two Experience components.  It is also a parent to the BasicPopover component
 * used to display the experience indended results.
 * @param {id, category, name, results, use, productWarings, productUsageAdvisory, image, estTime } : ExperienceObj
 * @returns
 */
export default function ListedExperience({
  id,
  category,
  name,
  use,
  estTime,
  image,
}: ExperienceObj) {
  return (
    <Box>
      <Card
        sx={{
          padding: "10px",
          margin: "30px",
          backgroundColor: "secondary.dark",
          color: "secondary.light",
          width: "85%",
          height: 3 / 4,
          zIndex: 1,
          borderColor: "secondary.light",
          borderWidth: 10,
        }}
      >
        <Typography
          sx={{ bgcolor: "secondary.dark", color: "secondary.light" }}
          align="center"
        >
          <CardHeader title={name}>{name}</CardHeader>
        </Typography>
        <CardMedia
          component="img"
          sx={{
            height: 540,
            objectFit: "contain",
            backgroundColor: "secondary.dark",
            zIndex: 1,
          }}
          image={"/" + image}
          title={name}
        />
        <CardContent
          sx={{
            color: "secondary.light",
            bgcolor: "secondary.dark",
            overflow: "visible",
            height: "205px",
            zIndex: 1,
          }}
        >
          <Typography
            variant="body1"
            component="div"
            style={{
              height: "135px",
              backgroundColor: "secondary.dark",
              color: "secondary.light",
              marginBottom: "5px",
              zIndex: 1,
            }}
          >
            {use}
          </Typography>
          <Typography
            variant="body1"
            component="div"
            style={{
              backgroundColor: "secondary.dark",
              color: "secondary.light",
              marginBottom: "5px",
              zIndex: 1,
            }}
          >
            {"Est time: " + estTime}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
